<template>
  <!-- eslint-disable vue/no-v-html -->
  <div style="position: relative">
    <div
      style="flex-grow: 1"
      @dblclick="selectElement"
      @click="$emit('onClick')"
      v-html="sanitizedHtml"
    ></div>
    <div
      @click="$emit('removeElement')"
      class="remove-button"
      v-tooltip.right="'Remove element'"
    >
      <ph-trash :size="28" />
    </div>
    <div class="text-editor" ref="editor" :style="maxHeight">
      <div
        v-if="(element.type == 'link' || element.type == 'image') && selected"
      >
        <p>Name</p>
        <input
          class="field"
          type="text"
          @input="handleInputForObject"
          :value="selectedElement.value.name"
        />
        <p>Url</p>
        <input
          class="field"
          type="url"
          @input="handleInputForObject($event, 'url')"
          :value="selectedElement.value.url"
        />
      </div>

      <vue-easymde
        v-if="
          element.type != 'link' &&
          element.type != 'image' &&
          element.type != 'list' &&
          selected
        "
        :value="selectedElement.value"
        :configs="easyMdConfig"
        ref="markdownEditor"
        @update:modelValue="handleInput"
      />

      <list-editor
        v-if="element.type == 'list' && selected"
        :list="selectedElement.value"
        @addListItem="addNewListItem"
        @removeListItem="removeListItem"
      />
    </div>
  </div>

  <!--eslint-enable-->
</template>

<script>
//  @update:modelValue="handleInput"
import DOMPurify from "dompurify";
import marked from "marked";
import { getElementMarkdown, trimString } from "../utils/helpers";
import { mapActions, mapGetters } from "vuex";
import ListEditor from "./ListEditor.vue";
import { PhTrash } from "phosphor-vue";
export default {
  name: "Element",
  data() {
    return {
      height: 0,
      elementValue: null,
    };
  },
  components: { ListEditor, PhTrash },
  props: {
    element: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    selectElement() {
      this.$emit("selectElement");
      this.elementValue = this.selectedElement.value;
    },
    handleInput(e) {
      // do some things
      this.setElementValueById(trimString(e));
    },
    handleInputForObject(e, type = "name") {
      let input = {
        name: "",
        url: "",
      };

      if (type == "name") {
        input.name = e.target.value;
        input.url = this.selectedElement.value.url;
      } else if (type == "url") {
        input.name = this.selectedElement.value.name;
        input.url = e.target.value;
      }
      // do some things
      this.setElementValueById(input);
    },
    ...mapActions(["setElementValueById", "addNewListItem", "removeListItem"]),
  },
  computed: {
    sanitizedHtml() {
      return DOMPurify.sanitize(marked(getElementMarkdown(this.element)));
    },
    easyMdConfig() {
      return {
        status: false, // disable the status bar at the bottom
        spellChecker: false, // disable spell check
        sideBySideFullscreen: false,
        syncSideBySidePreviewScroll: false,
        nativeSpellcheck: false,
        promptURLs: true,
        maxHeight: "200px",
        toolbar: this.toolbarOptions,
      };
    },
    maxHeight() {
      return `max-height: ${this.selected ? 400 : this.height}px`;
    },
    toolbarOptions() {
      switch (this.element.type) {
        case "codeblock":
        case "line":
        case "code":
          return [];
        case "quote":
          return ["bold", "italic", "strikethrough", "link"];
        case "paragraph":
          return [
            "bold",
            "italic",
            "strikethrough",
            "link",
            "code",
            "unordered-list",
            "ordered-list",
            "table",
            "quote",
          ];
        case "heading":
          return ["italic", "strikethrough", "link"];
        default:
          return ["bold", "italic", "strikethrough", "link"];
      }
    },
    ...mapGetters(["selectedElement"]),
  },
};
</script>

<style lang="scss">
.CodeMirror,
.CodeMirror-scroll {
  // max-height: 200px;
  margin-bottom: 1rem;
}

.editor-preview {
  display: none !important;
}

.text-editor {
  background-color: transparent;
  transition: max-height 0.2s ease-out;
  overflow: hidden;
  max-height: 0;
  min-height: 0;
  min-width: 0;
  margin-top: 1rem;
  overflow: hidden;
}
.d-flex {
  display: flex;
}
.field {
  background-color: #494647;
  color: white;
  // border-radius: 2px;
  border: 1px solid rgba(3, 3, 3, 0.171);
  padding: 1rem;
  font-family: "Rubik";
  margin-bottom: 1.5rem;
  width: 100%;
  transition: all 0.2s ease;
  &:focus {
    background-color: #494647;
    color: white;
    // border-radius: 2px;
    border: 1px solid rgba(255, 255, 255, 0.692);
    padding: 1rem;
    outline: none;
  }
}

.remove-button {
  position: absolute;
  right: 1rem;
  top: 0;
  cursor: pointer;
  color: #d82c2c;
  transition: all 0.2s ease;
  &:hover {
    color: #ac2121;
  }
}
</style>
